import { ReactComponent as StarIcon } from '../../assets/icons/estrela-preenchida.svg';
import { ReactComponent as HalfStarIcon } from '../../assets/icons/estrela-meio.svg';
import { ReactComponent as EmptyStarIcon } from '../../assets/icons/estrela-vazia.svg';
import { useTheme, Box, Typography, Stack, Divider } from '@mui/material';

const ReviewBox = ({ review }) => {
  const { userName, commentary, rating } = review;
  let stars = [];
  const theme = useTheme();

  const starIconStyle = {
    width: '24px',
    height: '24px',
    color: '#EBB113',
    fill: '#EBB113',
  };

  for (let i = 0; i < 5; i++) {
    let diff = rating - i * 2;

    if (diff > 1) {
      stars.push(<StarIcon key={i} style={starIconStyle} />);
    } else if (diff === 1) {
      stars.push(<HalfStarIcon key={i} style={starIconStyle} />);
    } else {
      stars.push(<EmptyStarIcon key={i} style={starIconStyle} />);
    }
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',
        flex: 1,
      }}
    >
      <Divider
        sx={{
          borderColor: theme.palette.primary.main,
          borderWidth: '1px',
          width: '100%',
          marginBottom: theme.spacingValues.medium,
        }}
      />

      <Box sx={{ flex: 1, width: '100%' }}>
        <Typography
          variant="body1"
          sx={{
            marginBottom: theme.spacingValues.medium,
            color: theme.palette.primary.contrastText,
          }}
        >
          "{commentary}"
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'space-between',
          width: '100%',
          height: '100%',
        }}
      >
        <Typography
          variant="h4"
          sx={{ color: theme.palette.primary.contrastText }}
        >
          {userName}
        </Typography>
        <Stack direction="row" spacing={1}>
          {stars}
        </Stack>
      </Box>
    </Box>
  );
};

export default ReviewBox;
